// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__7D0X-","content":"Consent_content__23dpv","footer":"Consent_footer__24sjw"};